var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
(() => {
  const config = window.FoxTheme && FoxTheme.campaignGift;
  if (!config || !config.enabled) return;
  const triggerCodes = (config.triggerCodes || (config.triggerCode ? [config.triggerCode] : [])).map((c) => String(c).toUpperCase()).filter(Boolean);
  if (!triggerCodes.length) return;
  const giftCodes = (config.giftCodes || (config.giftCode ? [config.giftCode] : [])).map((c) => String(c).toUpperCase()).filter(Boolean);
  if (!config.includesGift || !config.giftVariantId || !giftCodes.length) return;
  const GIFT_PROPERTIES = { _gift: "true", _campaign: "Promo code rewards" };
  class CampaignGift {
    constructor(cfg) {
      this.cfg = cfg;
      this.giftVariantId = Number(cfg.giftVariantId);
      this.triggerCodes = triggerCodes;
      this.giftCodes = giftCodes;
      this.busy = false;
      this.pending = false;
      this.reconcile = this.reconcile.bind(this);
      this.onDiscountSubmit = this.onDiscountSubmit.bind(this);
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, this.reconcile);
      document.addEventListener("submit", this.onDiscountSubmit, true);
      document.addEventListener("cart:updated", () => {
        if (this.busy) this.lockCheckout(true);
      });
      if (document.readyState !== "loading") {
        this.reconcile();
      } else {
        document.addEventListener("DOMContentLoaded", this.reconcile, { once: true });
      }
    }
    // Intercept coupon form: for campaign trigger codes, add the gift first so
    // gift-only discounts (100% off the gift product) can apply successfully.
    onDiscountSubmit(event) {
      const form = event.target;
      if (!form || form.getAttribute("is") !== "cart-discount") return;
      const couponEl = form.querySelector('input[name="discount"]');
      if (!couponEl) return;
      const rawCode = String(couponEl.value || "").trim();
      if (!rawCode) return;
      if (!this.triggerCodes.includes(rawCode.toUpperCase())) return;
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      this.applyTriggerWithGift(form, rawCode);
    }
    applyTriggerWithGift(form, rawCode) {
      return __async(this, null, function* () {
        const submitEl = form.querySelector('[type="submit"]');
        const messageEl = form.querySelector(".form__message");
        const couponEl = form.querySelector('input[name="discount"]');
        const showError = (msg) => {
          if (!messageEl) {
            if (msg) alert(msg);
            return;
          }
          messageEl.classList.toggle("!hidden", !msg);
          if (msg) messageEl.innerText = msg;
        };
        if (submitEl && submitEl.getAttribute("aria-disabled") === "true") return;
        if (this.busy) return;
        showError(false);
        this.busy = true;
        this.lockCheckout(true);
        this.setLoading(true);
        if (submitEl) {
          submitEl.setAttribute("aria-disabled", "true");
          submitEl.classList.add("btn--loading");
        }
        let giftAdded = false;
        try {
          let cart = yield this.fetchCart();
          const sections = this.collectSections();
          const existing = this.appliedCodes(cart).map((c) => String(c).toUpperCase());
          if (existing.includes(rawCode.toUpperCase())) {
            showError(FoxTheme.cartStrings.duplicateDiscountError);
            return;
          }
          if (!this.findGiftLine(cart)) {
            yield this.addGift(sections);
            giftAdded = true;
            cart = yield this.fetchCart();
          }
          const codes = this.appliedCodes(cart);
          if (!codes.some((c) => String(c).toUpperCase() === rawCode.toUpperCase())) {
            codes.push(rawCode);
          }
          if (!codes.some((c) => this.giftCodes.includes(String(c).toUpperCase()))) {
            codes.push(this.giftCodes[0]);
          }
          const parsedState = yield this.setDiscounts(codes, sections);
          const matched = (parsedState.discount_codes || []).find(
            (d) => d.code && d.code.toUpperCase() === rawCode.toUpperCase()
          );
          if (matched && matched.applicable === false) {
            if (couponEl) couponEl.value = "";
            showError(FoxTheme.cartStrings.applyDiscountError);
            if (giftAdded) {
              const giftLine = this.findGiftLine(yield this.fetchCart());
              if (giftLine) {
                yield this.changeGiftQuantity(giftLine.key, 0, sections);
              }
              const cleaned = this.removeGiftCodesFromList(this.appliedCodes(yield this.fetchCart()).filter((c) => String(c).toUpperCase() !== rawCode.toUpperCase()));
              yield this.setDiscounts(cleaned, sections);
            }
            const freshFail = yield this.fetchCart();
            freshFail.sections = yield this.renderSections();
            this.publish(freshFail);
            return;
          }
          if (couponEl) couponEl.value = "";
          const addonDrawer = form.closest(".cart-addons-drawer");
          if (addonDrawer && typeof addonDrawer.hide === "function") addonDrawer.hide();
          const fresh = yield this.fetchCart();
          fresh.sections = yield this.renderSections();
          this.publish(fresh);
          if (this.findGiftLine(fresh)) this.pendingToast = true;
        } catch (e) {
          console.error("[campaign-gift]", e);
          showError(FoxTheme.cartStrings.applyDiscountError);
        } finally {
          this.busy = false;
          this.lockCheckout(false);
          this.setLoading(false);
          if (submitEl) {
            submitEl.removeAttribute("aria-disabled");
            submitEl.classList.remove("btn--loading");
          }
          if (this.pendingToast) {
            this.pendingToast = false;
            this.showToast();
          }
        }
      });
    }
    // Disable/enable the checkout buttons so the customer can't check out while
    // the cart is in an intermediate state (gift being added or removed).
    lockCheckout(locked) {
      const buttons = document.querySelectorAll(
        '[name="checkout"], .shopify-payment-button__button, .additional-checkout-button'
      );
      buttons.forEach((btn) => {
        btn.toggleAttribute("disabled", locked);
        btn.setAttribute("aria-disabled", locked ? "true" : "false");
        btn.classList.toggle("campaign-gift-checkout-locked", locked);
      });
    }
    // Overlay a loading spinner over the cart drawer / cart page while the cart
    // is being updated. Targets stable containers that survive re-render.
    setLoading(loading) {
      document.querySelectorAll("cart-drawer .drawer__content, main-cart").forEach((el) => el.classList.toggle("campaign-gift-loading", loading));
    }
    // ---- helpers -------------------------------------------------------------
    collectSections() {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections } })
      );
      return sections;
    }
    // Fetch fresh section HTML from the server for every cart section currently
    // on the page, keyed by section id (the shape onCartUpdate expects).
    renderSections() {
      return __async(this, null, function* () {
        const ids = [...new Set(this.collectSections())];
        const result = {};
        yield Promise.all(
          ids.map((id) => __async(this, null, function* () {
            const res = yield fetch(`${FoxTheme.routes.root_url}?section_id=${encodeURIComponent(id)}`);
            result[id] = yield res.text();
          }))
        );
        return result;
      });
    }
    fetchCart() {
      return fetch(`${FoxTheme.routes.cart_url}.js`, { headers: { Accept: "application/json" } }).then(
        (r) => r.json()
      );
    }
    isTriggerActive(cart) {
      return (cart.discount_codes || []).some(
        (d) => d.code && this.triggerCodes.includes(d.code.toUpperCase()) && d.applicable
      );
    }
    isGiftCodeApplied(cart) {
      if (!this.giftCodes.length) return true;
      return (cart.discount_codes || []).some((d) => d.code && this.giftCodes.includes(d.code.toUpperCase()));
    }
    appliedCodes(cart) {
      return (cart.discount_codes || []).map((d) => d.code).filter(Boolean);
    }
    removeGiftCodesFromList(codes) {
      return codes.filter((c) => !this.giftCodes.includes(String(c).toUpperCase()));
    }
    // Identify the gift strictly by the property we tag it with, so we never
    // touch a unit of the same product the customer genuinely bought.
    findGiftLine(cart) {
      return (cart.items || []).find((item) => item.properties && item.properties._gift === "true");
    }
    addGift(sections) {
      const body = JSON.stringify({
        items: [{ id: this.giftVariantId, quantity: 1, properties: GIFT_PROPERTIES }],
        sections,
        sections_url: window.location.pathname
      });
      return fetch(`${FoxTheme.routes.cart_add_url}`, __spreadProps(__spreadValues({}, FoxTheme.utils.fetchConfig("javascript")), { body })).then(
        (r) => r.json()
      );
    }
    // `idOrKey` must be the line item key when the line carries properties
    // (a bare variant id will not match a line that has line item properties).
    changeGiftQuantity(idOrKey, quantity, sections) {
      const body = JSON.stringify({
        id: idOrKey,
        quantity,
        sections,
        sections_url: window.location.pathname
      });
      return fetch(`${FoxTheme.routes.cart_change_url}`, __spreadProps(__spreadValues({}, FoxTheme.utils.fetchConfig("javascript")), { body })).then(
        (r) => r.json()
      );
    }
    setDiscounts(codes, sections) {
      const config2 = FoxTheme.utils.fetchConfig("javascript");
      config2.headers["X-Requested-With"] = "XMLHttpRequest";
      delete config2.headers["Content-Type"];
      const formData = new FormData();
      formData.append("discount", codes.join(","));
      formData.append("sections", sections);
      formData.append("sections_url", window.location.pathname);
      config2.body = formData;
      return fetch(`${FoxTheme.routes.cart_update_url}`, config2).then((r) => r.json());
    }
    publish(cart) {
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart, source: "campaign-gift" });
    }
    // ---- main reconciliation -------------------------------------------------
    reconcile(event) {
      return __async(this, null, function* () {
        if (event && event.source === "campaign-gift") return;
        if (this.busy) {
          this.pending = true;
          return;
        }
        this.busy = true;
        this.lockCheckout(true);
        this.setLoading(true);
        try {
          let cart = yield this.fetchCart();
          const active = this.isTriggerActive(cart);
          let giftLine = this.findGiftLine(cart);
          let changed = false;
          let added = false;
          let lastState = null;
          if (active) {
            const sections = this.collectSections();
            if (!giftLine) {
              lastState = yield this.addGift(sections);
              added = true;
              changed = true;
            } else if (giftLine.quantity > 1) {
              lastState = yield this.changeGiftQuantity(giftLine.key, 1, sections);
              changed = true;
            }
            if (!this.isGiftCodeApplied(cart)) {
              const codes = this.appliedCodes(cart);
              codes.push(this.giftCodes[0]);
              lastState = yield this.setDiscounts(codes, sections);
              changed = true;
            }
          } else if (giftLine || this.isGiftCodeApplied(cart)) {
            const sections = this.collectSections();
            if (giftLine) {
              lastState = yield this.changeGiftQuantity(giftLine.key, 0, sections);
            }
            if (this.isGiftCodeApplied(cart)) {
              const codes = this.removeGiftCodesFromList(this.appliedCodes(cart));
              lastState = yield this.setDiscounts(codes, sections);
            }
            changed = true;
          }
          if (changed) {
            const fresh = yield this.fetchCart();
            fresh.sections = yield this.renderSections();
            this.publish(fresh);
            if (added && this.findGiftLine(fresh)) this.pendingToast = true;
          }
        } catch (e) {
          console.error("[campaign-gift]", e);
        } finally {
          this.busy = false;
          if (this.pending) {
            this.pending = false;
            this.reconcile();
          } else {
            this.lockCheckout(false);
            this.setLoading(false);
            if (this.pendingToast) {
              this.pendingToast = false;
              this.showToast();
            }
          }
        }
      });
    }
    // ---- toast ---------------------------------------------------------------
    // Reveal the confirmation message. The element is rendered server-side and
    // always present in the drawer body; here we only toggle its visibility.
    showToast() {
      const el = document.querySelector(".campaign-gift-toast");
      if (!el) return;
      el.classList.add("is-visible");
      clearTimeout(this._toastTimer);
      this._toastTimer = setTimeout(() => el.classList.remove("is-visible"), 4e3);
    }
  }
  new CampaignGift(config);
})();
